import { useTranslation } from 'react-i18next';
import { useParamsSearch } from '@anytag/shared-hooks';
import { ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useInstagramAnalyticsListCommentsQuery } from '@anytag/graphql';
import { ProfilePostsFilter, AnalyticsInstagramCommentsList } from '@anytag/shared-organisms';
import { useInitialAnalyticsPosts } from '../hooks';
import { AnalyticsIgCommentsSearchSchemaType } from './schema-types';

export const AnalyticsInstagramComments = () => {
  const { t } = useTranslation();
  const { brandAccountId, mainSocialAccountId } = useInitialAnalyticsPosts({
    socialMedia: 'instagram',
    document: (name) => ({
      title: name ? 'appHeader.IGCommentListWithAccountName' : 'Comment List',
      appHeader: name ? 'appHeader.IGCommentListWithAccountName' : 'Comment List'
    })
  });
  const { page, limit, filter, setFilter } = useParamsSearch<AnalyticsIgCommentsSearchSchemaType>();
  const { data, previousData, loading } = useInstagramAnalyticsListCommentsQuery({
    skip: !brandAccountId || !mainSocialAccountId,
    variables: getValuableVariables({
      limit,
      keyword: filter.keyword,
      offset: getOffset(page, limit),
      instagramAnalyticsAccountId: Number(mainSocialAccountId)
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.instagramAnalyticsListCommentsCount?.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <ProfilePostsFilter filter={filter} setFilter={setFilter} keywordPlaceholder={t<string>('Search.keywords')} />

      <AnalyticsInstagramCommentsList
        loading={loading}
        totalRecords={totalRecords}
        data={result?.instagramAnalyticsListComments.comments || []}
      />
    </ListWithPagination>
  );
};
